export enum EAdminRoutesNames {
  // base
  AdminNotFoundPage = 'AdminNotFoundPage',
  AdminForbiddenPage = 'AdminForbiddenPage',

  AdminNotificationTypesPage = 'AdminNotificationTypesPage',
  AdminNotificationsPage = 'AdminNotificationsPage',
  AdminRecipientsPage = 'AdminRecipientsPage',
  AdminSubscriptionsPage = 'AdminSubscriptionsPage',
  AdminNotificationRolesPage = 'AdminNotificationRolesPage',
  AdminEventCategoriesPage = 'AdminEventCategoriesPage',
  AdminEventObjectTypesPage = 'AdminEventObjectTypesPage',
  AdminEventTypesPage = 'AdminEventTypesPage',
  AdminEventsPage = 'AdminEventsPage',
}
